import * as React from 'react';
import classNames from 'classnames';

import { ChecklistEnum, OnboardingSteps } from './model';
import HelpArticleButton, {
  onContactSupport
} from '../../../utils/HelpArticleButton';
import { Button } from 'antd';
import Animation from './Animation';
import * as translations from './strings';
import { getLangKey } from 'models/Language';
import styles from './index.module.css';

const strings = translations[getLangKey()];

const RightPanel = ({
  step,
  showEmbedJavascript
}: {
  step: ChecklistEnum;
  organizationId: number;
  userId: number;
  showEmbedJavascript: boolean;
  elevioArticleId?: string;
}) => {
  const { rightPanelImage } = OnboardingSteps[step];
  const helpArticleId = OnboardingSteps[step].helpArticleId;
  const showConciergeHelp = ChecklistEnum.WEBSITE === step;

  const TalkToUs: React.FC = () => (
    <span className={styles.talkToUsOuter}>
      {strings.helpMessagePartOne}
      <a onClick={onContactSupport}>{strings.helpMessagePartTwo}</a>
    </span>
  );

  const ConciergeHelp: React.FC = () => (
    <div className={styles.conciergeHelp}>
      <p>{strings.conciergeHelp1} </p>
      <Button
        onClick={() =>
          window.open('https://bugherd.typeform.com/to/wIfihfHy', '_blank')
        }
        type="link"
      >
        {strings.conciergeHelp2}
      </Button>
    </div>
  );

  const getContentForRightPanel = () => {
    if (step === ChecklistEnum.INVITE_TEAM && rightPanelImage) {
      return (
        <div className={styles.guideOuter}>
          <img
            className={styles.rightPanelImage}
            src={rightPanelImage}
            alt="invite-team-onboarding"
          />
        </div>
      );
    }

    if (step !== ChecklistEnum.INVITE_TEAM) {
      const hideTitleAndTooltip = step === ChecklistEnum.SETUP_PROJECT;
      const hasGuideContent =
        !hideTitleAndTooltip || !!OnboardingSteps[step].guideMessagePara;

      return (
        <div className={styles.guideOuter}>
          {hasGuideContent && (
            <div className={styles.guideInfo}>
              {!hideTitleAndTooltip && (
                <>
                  {helpArticleId && (
                    <HelpArticleButton articleId={helpArticleId} />
                  )}
                  <h3 className={styles.guideMessage}>
                    {OnboardingSteps[step].guideMessage}
                  </h3>
                </>
              )}
              {OnboardingSteps[step].guideMessagePara && (
                <p>{OnboardingSteps[step].guideMessagePara}</p>
              )}
            </div>
          )}
          <>
            <Animation
              step={step}
              showEmbedJavascript={
                step === ChecklistEnum.INSTALL_BH
                  ? showEmbedJavascript
                  : undefined
              }
            />
            {showConciergeHelp ? <ConciergeHelp /> : <TalkToUs />}
          </>
        </div>
      );
    }

    return <TalkToUs />;
  };

  return (
    <div
      className={classNames({
        [styles.rightPanelInner]: true,
        [styles.setupProjectRightPanel]: step === ChecklistEnum.SETUP_PROJECT,
        [styles.installExtensionRightPanel]:
          step === ChecklistEnum.INSTALL_BH && !showEmbedJavascript,
        [styles.installJavascriptRightPanel]:
          step === ChecklistEnum.INSTALL_BH && showEmbedJavascript,
        [styles.websiteRightPanel]: step === ChecklistEnum.WEBSITE
      })}
    >
      {getContentForRightPanel()}
    </div>
  );
};
export default RightPanel;
